import React, { useEffect, useState } from "react";
import Loader from "../loader/Loader.jsx";
import ExtensionCard from "../ExtensionCard/ExtensionCard.jsx";

const ManageExtension = () => {
  const [isDisable, setIsDisable] = useState(false);
  const [isLoader, setisLoader] = useState(false);
  const [isExtEnabled, setIsExtEnabled] = useState(false);

  const extensionID = process.env.REACT_APP_EXTENSION_ID;

  // Listen for messages from the content script
  const handleMessage = (event) => {
    if (event.data.extensionInfo === "ExtensionIsDisabled") {
      setIsExtEnabled(false);
    }

    if (
      event.data.type === "EXTENSION_INFO_RESPONSE" &&
      event.data?.extensionInfo
    ) {
      setIsDisable(event.data?.extensionInfo?.enabled);
      setTimeout(() => {
        setisLoader(false);
      }, 1000);
    } else if (event.data.type === "TOGGLE_EXTENSION") {
      setIsDisable((prev) => !prev);
      setTimeout(() => {
        setisLoader(false);
      }, 1000);
    }
  };

  const handleExtensionState = (event) => {
    if (
      event.data.type === "EXTENSION_INFO_RESPONSE" &&
      event.data?.extensionInfo !== "ExtensionIsDisabled"
    ) {
      setIsExtEnabled(true);
    }
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);

    // Send the message after adding the event listener
    window.postMessage(
      { type: "GET_EXTENSION_INFO", id: process.env.REACT_APP_EXTENSION_ID },
      "*"
    );

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [isDisable]);

  useEffect(() => {
    window.addEventListener("message", handleExtensionState);

    // Send the message after adding the event listener
    window.postMessage(
      { type: "GET_EXTENSION_INFO", id: process.env.REACT_APP_EXTENSION_ID },
      "*"
    );

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("message", handleExtensionState);
    };
  }, []);

  const handleToggle = () => {
    setisLoader(true);
    window.postMessage({ type: "TOGGLE_EXTENSION" }, "*");
  };

  return (
    <div>
      {isLoader && <Loader />}
      <div>
        <ExtensionCard
          handleToggle={handleToggle}
          isDisable={isDisable}
          setIsDisable={setIsDisable}
          isExtEnabled={isExtEnabled}
        />
      </div>
    </div>
  );
};

export default ManageExtension;
